export default __webpack_public_path__ + "static/media/0q.b582c450.png";